import { Injectable } from '@angular/core';
import { ModalOverlayComponent } from './modal-overlay.component';

export interface ModalOverlay {
  modal: ModalOverlayComponent;
  id: string;
}

@Injectable({
  providedIn: 'root',
})
export class ModalOverlayService {
  constructor() {}
  public modals: ModalOverlay[] = [];

  public addModal(modal: ModalOverlay) {
    const idx = this.modals.findIndex((m) => m.id === modal.id);
    if (idx > -1) {
      this.modals[idx].modal = modal.modal;
    } else {
      this.modals.push(modal);
    }
  }

  public getModal(id: string): ModalOverlayComponent {
    const modal = this.modals.find((m: ModalOverlay) => m.id === id);
    if (modal !== undefined) {
      return modal.modal;
    }
  }

  public get(id: string): ModalOverlayComponent {
    return this.getModal(id);
  }

  public open(id: string) {
    let modal;
    if ((modal = this.get(id))) {
      modal.open();
    }
  }

  public close(id: string): void {
    let modal;
    if ((modal = this.get(id))) {
      modal.close();
    }
  }

  public removeModal(id: string): void {
    const idx: number = this.modals.findIndex((o: any) => o.id === id);
    if (idx > -1) {
      this.modals.splice(idx, 1);
    }
  }
}
